// extracted by mini-css-extract-plugin
export var container = "_dr-0";
export var icon = "_dr-1";
export var text = "_dr-2";